module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "indback-bar",
    on: {
      "click": _vm.goback
    }
  }, [_c('i', {
    staticClass: "iconfont icon-leftdefalut"
  }), _vm._v(" "), _c('span', [_vm._v("返回")])]), _vm._v(" "), _c('div', {
    staticClass: "jobfair-box"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('ul', {
    staticClass: "jobfair-compy"
  }, [_c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "j-c-tit"
  }, [_vm._v("管理者姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adminName),
      expression: "adminName"
    }],
    staticClass: "j-c-inp",
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名"
    },
    domProps: {
      "value": (_vm.adminName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.adminName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "clearfix j-c-secondli"
  }, [_c('div', {
    staticClass: "j-c-tit"
  }, [_vm._v("管理者联系电话")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adminPhone),
      expression: "adminPhone"
    }],
    staticClass: "j-c-inp",
    attrs: {
      "type": "number",
      "placeholder": "请输入联系电话"
    },
    domProps: {
      "value": (_vm.adminPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.adminPhone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "j-c-tit"
  }, [_vm._v("执照号码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.license),
      expression: "license"
    }],
    staticClass: "j-c-inp",
    attrs: {
      "type": "text",
      "placeholder": "请输入营业执照号码或统一社会信用代码"
    },
    domProps: {
      "value": (_vm.license)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.license = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "j-c-tit"
  }, [_vm._v("营业执照")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading2),
      expression: "loading2"
    }],
    staticClass: "yefilebox",
    attrs: {
      "element-loading-text": "上传中，请稍等"
    }
  }, [_c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.licenseChange
    }
  }), _vm._v(" "), (_vm.licenseImg) ? _c('img', {
    staticClass: "yefile-chuan",
    attrs: {
      "src": _vm.licenseImg
    }
  }) : _c('img', {
    staticClass: "yefile-chuan",
    attrs: {
      "src": require("../../assets/images/picchuan.png")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "gorz",
    on: {
      "click": _vm.gorz
    }
  }, [_vm._v("确认认证")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jobf-tobar"
  }, [_c('div', {
    staticClass: "jobf-tit jobf-tit-before"
  }, [_vm._v("企业认证"), _c('span', {
    staticClass: "jobf-tit-fu"
  }, [_vm._v("（请填写真实企业信息）")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-539f6b06","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/compyrz.vue
// module id = 879
// module chunks = 1